import { toUTC } from 'helpers/day';

enum GTM_EVENTS {
  FIRST_TRADE = 'first_trade',
  FOURTEEN_DAY_COMMISSION = '14D_commission',
}

const TRACKING_INFO_KEYS_FOR_EVENT_TRACKING = {
  [GTM_EVENTS.FIRST_TRADE]: 'is_first_trade_gtm_tracked',
  [GTM_EVENTS.FOURTEEN_DAY_COMMISSION]: 'is_14D_fees_gtm_tracked',
};

/**
 * @description
 * Date after which we will start tracking first trade as we might not  have first trade data for old users.
 */
const FIRST_TRADE_GTM_TRACKING_START_DATE = toUTC('2025-02-10T00:00:00Z');

export {
  GTM_EVENTS,
  TRACKING_INFO_KEYS_FOR_EVENT_TRACKING,
  FIRST_TRADE_GTM_TRACKING_START_DATE,
};
